import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import {uploadDocument} from '../../actions/user-api';
import {FileTypes} from '../../constants/utils/fileTypes';
import * as R from 'ramda';
import $ from 'jquery';

export const ModalEditFolder = ({userId, currentPath, onFolderEdited }) => {
	const dispatch = useDispatch();
	const formRef = useRef();
	const [dossierName, setDossierName] = useState('');
	const [isLoading, setIsLoading] = useState(false);


	return (
		<div className="modal fade px-0" id="ModalEditFolder" aria-labelledby="gestionLabel" aria-hidden="true">
			<div className="modal-dialog container-copy px-2">
				<div className="modal-content">
					<header className="modal-header">
						<div className="alert bg-alert-aux rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Gestion docs</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-aux text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="gestionLabel">Créer un dossier personnalisé</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body scroll-default pt-0">
						{/* <p className="h4 o-66 text-aux">Gérer les Dossiers</p> */}
						<form className="block" noValidate ref={formRef}>
							<div className="form-group">
								<label className="h6 font-weight-bolder" htmlFor="nl">Nom du Dossier :</label>
								<input id="nl" className="form-control" placeholder="Dossier 1" value={dossierName} onChange={(e) => setDossierName(e.target.value)} required />
							</div>
						</form>
						<div className="flex-row justify-content-between pt-0 mt-3">
							{/* <button type="button" className="btn btn-light" data-dismiss="modal">Annuler</button> */}
							<div className="flex-row justify-content-end ml-auto">
								<button type="button" className="btn btn-light ms-auto" data-dismiss="modal">Annuler</button>
								<button type="button" className={"btn btn-aux loading-btn ml-2" + (isLoading ? " show" : "")} onClick={(e) => {
									e.preventDefault();
									formRef.current.classList.add('was-validated');
									if (formRef.current.checkValidity()){
										setIsLoading(true);
										dispatch(uploadDocument(userId, FileTypes.Folder, null, null, R.isNil(currentPath)?  dossierName : currentPath + "/" + dossierName))
										.then((uploadedFile) => {
											onFolderEdited(uploadedFile);
											setIsLoading(false);
											$('#ModalEditFolder').modal("hide");
											setDossierName("");
											formRef.current.classList.remove('was-validated')
										});
									}
								}}><div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Créer</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}